import type { AvailableDriversParams, SearchVehiclesParams } from './vehicle.api';

export const vehicleKeys = {
  all: ['vehicles'] as const,
  availableDrivers: (params: AvailableDriversParams): readonly unknown[] =>
    [...vehicleKeys.all, 'available-drivers', params] as const,
  list: (params: SearchVehiclesParams): readonly unknown[] => [...vehicleKeys.lists(), params] as const,
  lists: (): readonly string[] => [...vehicleKeys.all, 'list'] as const,
};
